import { render, staticRenderFns } from "./CardType.vue?vue&type=template&id=58cb5fae&"
import script from "./CardType.vue?vue&type=script&lang=js&"
export * from "./CardType.vue?vue&type=script&lang=js&"
import style0 from "./CardType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports